import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=87adeee8&"
import script from "./FileModal.vue?vue&type=script&lang=js&"
export * from "./FileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports